<template>
  <div class="virtual-tel-wrapper">
    <DialogPopup
      :customClass="'virtual-tel-dialog'"
      :show="showDialog"
      width="267px"
      :append-to-body="true"
    >
      <div class="box-style" v-r-loading="loading">
        <img v-if="type !== 'err'" class="top-bg" :src="require('./img/pic_numberprotect@3x.png')" alt="">
        <img v-else class="top-bg err-bg" :src="require('./img/dialog_icon_exclam@3x.png')" alt="">
        <div class="content-wrapper">
          <div class="center-box">
            <p
              class="center-box-text"
              v-for="(txt, indexTxt) in configContent[type].txtList"
              :key="indexTxt"
              v-text="txt"
            ></p>
            <div
              v-if="configContent[type].inputShow"
              class="phone-input-box"
            >
              <input type="text" readonly class="d-hide-input">
              <el-input
                class="calling-style el-input_d-reset"
                v-model="callingCode"
                @input="changeCalling"
                @blur="blurCalling"
              /><el-input
                class="tel-style el-input_d-reset"
                :placeholder="$t('电话号码')"
                v-model="phone"
                :clearable="true"
                oninput="value=value.replace(/[^\d]/g,'')"
              >
              </el-input>
            </div>
          </div>
          <div class="footer-box">
            <p
              class="btn-item"
              v-for="(btn, indexBtn) in configContent[type].btnList"
              :key="indexBtn"
              :class="{'high-light': btn.highlight}"
              v-text="btn.txt"
              @click="btnClick(btn)"
            ></p>
            <span class="line-border"></span>
          </div>
        </div>
      </div>
    </DialogPopup>
  </div>
</template>

<script>
/**
 * 号码保护弹窗组件
 * 提供号码保护提示、输入号码保护后拨打电话功能
 */
import { mapState } from 'vuex';

import api from '@/api';
import { Encrypt, Decrypt } from '@/utils/crypto';
import { countryCallingCode } from '@/config/countryConfig/list/login'
import {
  getLocalStorage,
  setLocalStorage,
} from '@/utils/localStorage';

import DialogPopup from '@/components/DialogPopup'

export default {
  name: 'VirtualTel',
  components: {
    DialogPopup
  },
  props: {
    orderId: String
  },
  data() {
    return {
      loading: false,
      showDialog: true,
      phone: '',
      userTelEntregaInfo: getLocalStorage('userTelEntregaInfo'),
      type: 'remind',
      configContent: {
        remind: {
          inputShow: false,
          txtList: [
            this.$t('为保护隐私，他人无法看到您的真实电话号码'),
          ],
          btnList: [
            {
              highlight: false,
              txt: this.$t('取消'),
              fnName: 'closePopup',
            },
            {
              highlight: true,
              txt: this.$t('确认'),
              fnName: 'remindConfirm'
            },
          ],
        },
        telInput: {
          inputShow: true,
          txtList: [
            this.$t('将使用以下号码加密呼出')
          ],
          btnList: [
            {
              highlight: false,
              txt: this.$t('取消'),
              fnName: 'closePopup',
            },
            {
              name: 'call',
              highlight: false,
              txt: this.isH5 ? this.$t('呼叫'): this.$t('确认'),
              fnName: 'callClick'
            },
          ],
        },
        err: {
          inputShow: false,
          txtList: [
            this.$t('网络异常，请稍后再试'),
          ],
          btnList: [
            {
              highlight: false,
              txt: this.$t('取消'),
              fnName: 'closePopup',
            },
            {
              name: 'call',
              highlight: true,
              txt: this.$t('确认'),
              fnName: 'closePopup'
            },
          ],
        },
        successPc: {
          inputShow: false,
          txtList: [],
          btnList: [
            {
              highlight: false,
              txt: this.$t('取消'),
              fnName: 'closePopup',
            },
            {
              name: 'call',
              highlight: true,
              txt: this.$t('确认'),
              fnName: 'closePopup'
            },
          ],
        }
      },
      callingCode: '+52',
    }
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      country: ({ common }) => common.country,
      orderStatus: ({ entrega }) => entrega.orderStatus,
    }),
    canCall() {
      return Boolean(this.phone && this.callingCode)
    },
  },
  watch: {
    canCall(nVal, oVal) {
      if (nVal !== oVal && nVal && this.type === 'telInput') {
        this.configContent[this.type].btnList[1].highlight = true
      }
    },
    country: {
      handler(nVal) {
        this.callingCode = countryCallingCode[nVal] || '+52'
      },
      immediate: true,
    }
  },
  created() {
    if (this.userTelEntregaInfo) {
      let { callingCode, phone } = this.userTelEntregaInfo
      this.phone = phone
      this.callingCode = callingCode
    }
    this.type = 'remind'
  },
  methods: {
    handleBtnLog(click_type = 0) {
      this.$trackEvent({
        eventId: 'sailing_c_e_landing_order_contact_rider_second_ck',
        eventLabel: '点击联系骑手后呼叫骑手号码保护点击',
        attrs: {
          order_id: this.orderId,
          order_status: this.orderStatus,
          click_type, // 确定1 取消2
        },
      })
    },
    getStore() {
      setLocalStorage('userTelEntregaInfo', {callingCode: this.callingCode, phone: this.phone, });

    },
    btnClick(item) {
      if (item.name === 'call' && !item.highlight) return
      this[item.fnName] && this[item.fnName]()
    },
    remindConfirm() {
      this.type = 'telInput'
      if (this.canCall && this.type === 'telInput') {
        this.configContent[this.type].btnList[1].highlight = true
      }
    },
    callClick() {
      let phone = Encrypt(this.phone);

      this.handleBtnLog(1);
      this.storeTel()
      this.getVirtualtelCall(phone);
    },
    async getVirtualtelCall(phone) {
      let data = null;
      this.loading = true
      try {
        data = await api.apiEntregaGetVirtualtelCall({
          orderId: this.orderId,
          phone: phone,
          callingCode: this.callingCode,
          role: 0, // 0 骑手 1 商家
        });
      } catch (err) {
        this.type = 'err'
        this.configContent[this.type].txtList = [
          this.$t('网络异常，请稍后再试')
        ]
      }
      this.loading = false;
      if (!data) return;
      let virtualPhone = Decrypt(data.virtualPhone);
      this.callPhone(virtualPhone)
    },
    // 号码保护出错直接呼叫
    errCall() {
      this.handleBtnLog(1);
      this.storeTel();
      this.callPhone(this.phone)
    },
    // 记住tel
    storeTel() {
      setLocalStorage('userTelEntregaInfo', {callingCode: this.callingCode, phone: this.phone});
    },
    // 打电话
    callPhone(phoneNum) {
      if (this.isH5) {
        // 打电话
        window.location.href = `tel:${phoneNum}`;
        return
      }

      this.type = 'successPc';
      this.configContent[this.type].txtList = [
        this.$t('CS_page_Courier_Phone_ghUr'),
        phoneNum
      ]
    },
    // 修改区号
    changeCalling() {
      // +号不能删除，其余能删除，只能输入数字
      if (this.callingCode.length < 0) {
        this.callingCode = '+';
      } else {
        this.callingCode = '+' + this.callingCode.replace(/[^\d]/g, '');
      }
    },
     // 如果失去焦点
    blurCalling() {
      if (this.callingCode === '+') {
        this.callingCode = this.userInfo?.callingCode;
      }
    },
    closeHook() {
      //
    },
    onClose() {
      this.closePopup()
    },
    closePopup() {
      this.showDialog = false
      this.closeHook()
      this.handleBtnLog(2);

      setTimeout(() => {
        this.$destroy()
        this.$el?.parentNode?.removeChild(this.$el)
      }, 200)
    }
  },
  destroyed() {
    // openScroll()
  },
}
</script>

<style lang="scss">
.virtual-tel-dialog {
  .el-dialog__body {
    padding: 0;
    min-height: 150px !important;
    background: #fff !important;
  }
}
</style>
<style lang="scss" scoped src="./index.scss"></style>